import { render, staticRenderFns } from "./ModalAddProducto.vue?vue&type=template&id=324842e6&scoped=true"
import script from "./ModalAddProducto.vue?vue&type=script&lang=js"
export * from "./ModalAddProducto.vue?vue&type=script&lang=js"
import style0 from "./ModalAddProducto.vue?vue&type=style&index=0&id=324842e6&prod&lang=css"
import style1 from "./ModalAddProducto.vue?vue&type=style&index=1&id=324842e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324842e6",
  null
  
)

export default component.exports